<template>
  <div style="height:100%">
    <!-- <BaseContainer style="height:100%" class="one_table"> -->
    <TableMain name="one table" ref="InventSumExportTable" :fields="fields" :title="table_title.title1"
      :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
      :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
      :isBusy="isBusy_table" :query_button_label="query_lable" :show_toolbar_button="[0, 0, 0, 0, 1]"
      @state_change="state_change" tableref="f2a6bad2c7454d5aa953d28806581ecc">
      <template #toolbar="">
        <div style="display: inline-block">
          <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/" accept=".xlsx"
            :on-exceed="exceed" :limit="1" :on-remove="remove" :http-request="uploadFile"
            :before-upload="beforeFileUpload" :show-file-list="false" :file-list="fileList" :on-success="successFile">
            <el-button plain type="info" style="width: 55px" class="ml-2"><i
                class="iconfont icon-export-in"></i></el-button>
            <!-- <div slot="tip" class="el-upload__tip">1次只能上传1个xls文件</div> -->
          </el-upload>
        </div>
        <el-select v-if="export_type == ''" v-model="exportType" style="width: 120px" size="small" class="ml-2"
          :placeholder="$t('notify.select_import_template')" @change="changeExportType">
          <el-option v-for="item in exportOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-tooltip content="模板下载" placement="top" effect="light">
          <el-button plain type="info" style="width: 55px" @click="downloadTemplate" class="ml-2"><i
              class="iconfont icon-template"></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #operation>
        <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveExport"
          :label="$t('common.save')" class="ml-2">
        </QueryButton>
      </template>
    </TableMain>
    <!-- </BaseContainer> -->
  </div>
</template>

<script>
import XLSX from "xlsx"
import * as InventTableController from "../../controllers/base/InventTableController"
import * as InventSumExportController from "../../controllers/wm/InventSumExportController"
import * as api from "../../shared/api"
import * as base_url from "../../shared/base_url"
import * as localStorageMgr from "../../shared/localStorageMgr"
import BaseContainer from "../components/BaseContainer"
import QueryButton from "../components/base/QueryButton"
import TableMain from "../components/table/TableMain"
export default {
  name: "InventSumExport",
  props: {
    export_type: { type: String, default: () => "" },
    is_pub: { type: Boolean, default: () => false },
  },
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      guest_info: null,
      fileList: [],
      table_title: {
        title1: "table_invent_sum_import",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: InventSumExportController.fields.default,
      dataList: [],
      isBusy_table: false,
      exportOptions: [
        { value: 1, label: this.$t("common.customer") + this.$t("common.import") },
        { value: 2, label: this.$t("common.provider") + this.$t("common.import") },
      ],
      exportType: 1,
      base_url: base_url.base_url,
    }
  },
  created() {
    if (localStorageMgr.data.guest_info && this.ls.get(localStorageMgr.data.guest_info))
      this.guest_info = JSON.parse(this.ls.get(localStorageMgr.data.guest_info))
  },
  mounted() {
    if (this.export_type == "vend") {
      this.exportType = 2
    } else {
      this.exportType = 1
    }
    this.changeExportType(this.exportType)
  },
  methods: {
    downloadTemplate() {
      if (this.exportType == 2) {
        window.location.href =
          this.base_url +
          "/excel_template/" +
          "现有库存量导入模板(供应商).xlsx"
      } else {
        window.location.href =
          this.base_url + "/excel_template/" + "现有库存量导入模板(客户)20240802.xlsx"
      }
    },
    changeExportType(val) {
      switch (val) {
        case 0:
          this.changedataAreaId(0)
          break
        case 1:
          this.changedataAreaId(1)
          break
        case 2:
          this.changedataAreaId(2)
          break
        default:
          break
      }
    },
    changedataAreaId(val) {
      this.$refs.InventSumExportTable.SetData([])
      let data = _.find(InventSumExportController.fields.default, {
        key: "dataAreaId",
      })
      if (val == 0) {
        data.label = this.$t("common.company")
      } else if (val == 1) {
        data.label = this.$t("common.customer") + this.$t("common.num")
      } else {
        data.label = this.$t("common.provider") + this.$t("common.num")
      }
    },
    state_change(data, cb) {
      if (data.state === "deleted") {
        this.$refs.InventSumExportTable.RemoveItems(data.selected_items)
      }
    },
    //上传1个以上文件时弹窗提示错误
    exceed: function () {
      this.msgToasts(this.$t("notify.most_1_xls_file"), "info")
    },
    //删除
    remove() { },
    successFile() {
      //this.isBusy_table3 = false
    },
    async uploadFile(params) {
      this.isBusy_table = true
      this.$refs.InventSumExportTable.SetData([])
      let _this = this
      let _file = params.file
      let fileReader = new FileReader()
      fileReader.onload = (ev) => {
        try {
          let data = ev.target.result
          let workbook = XLSX.read(data, {
            type: "binary",
            cellDates: true,
          })
          let listTable = []

          let _keys_sheets = _.keys(workbook.Sheets)
          let sheet = workbook.Sheets[_keys_sheets[0]]
          let sheetArray = XLSX.utils.sheet_to_json(sheet, { defval: "" })
          if (sheetArray.length == 0) {
            this.msgToasts(this.$t("notify.not_data"), "error")
            return
          }
          ///检查模板是否正确
          let _sheet_keys = _.keysIn(sheetArray[0])
          let _fields_keys = _.keysIn(_.keyBy(this.fields, "label"))
          let dif = _.difference(_fields_keys, _sheet_keys)
          if (dif.length > 0) {
            this.msgToasts(this.$t("notify.template_error"), "error")
            return
          }

          // console.log(sheetArray)
          _.each(sheetArray, (t) => {
            let _p = {}
            _.forIn(_.keyBy(this.fields, "label"), (v, k) => {
              if (_.isDate(t[k])) {
                _p[v.key] = _this.$date.format(
                  _this.$date.addDays(t[k], 1),
                  "yyyy-MM-dd"
                )
              } else {
                _p[v.key] = t[k]
              }
            })
            listTable.push(_p)
          })
          console.log(listTable)
          _this.$refs.InventSumExportTable.SetData(listTable)
        } catch (e) {
          this.msgToasts(this.$t("notify.file_type_error"), "info")

          this.isBusy_table = false
        }
      }
      fileReader.readAsBinaryString(_file)
      this.isBusy_table = false
      this.fileList = []
    },
    //before上传
    beforeFileUpload() { },
    //保存
    async saveExport(cb) {
      if (this.$refs.InventSumExportTable.my_data.length < 1) {
        cb(false)
        return
      }
      //检查数据是否有重复项
      let dataList = this.$refs.InventSumExportTable.my_data
      let _dataList = []
      _.each(dataList, (t) => {
        _dataList = _.filter(dataList, {
          dataAreaId: t.dataAreaId,
          ItemId: t.ItemId,
        })
        if (_dataList.length > 1) {
          this.msgToasts(this.$t("common.company") + ": " + t.dataAreaId + this.$t("common.invent") + " : " + t.ItemId + this.$t("notify.data_is_repeat") + " !", "info")
          return false
        }
      })
      if (_dataList.length > 1) {
        _.each(_dataList, (t) => {
          let item = this.$refs.InventSumExportTable.my_data[parseInt(t._id)]
          item._rowVariant = "danger"
          item._selected = true
          this.$set(this.$refs.InventSumExportTable.my_data, t._id, item)
        })

        cb(false)
        return
      }
      let _this = this
      if (this.$refs.InventSumExportTable.my_data.length == 0) {
        cb(false)
        return
      }
      let _is_ok = true
      let _data = _.cloneDeep(this.$refs.InventSumExportTable.my_data)
      const loading = this.$loading({
        lock: true,
        text: this.$t("notify.data_check_waiting") + "...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      })
      //获取物料信息并检查
      //_is_ok = await this.getNameAlias(_data);
      let Group = _.groupBy(
        this.$refs.InventSumExportTable.my_data,
        "DataSource"
      )
      if (Group.length > 1) {
        this.msgToasts(this.$t("notify.must_import_1_company_file"), "infgo")
        cb(false)
        return
      }

      loading.close()
      if (_is_ok) {
        this.msgModal(this.$t("notify.is_continue")).then(async (value) => {
          if (value) {
            ///整理数据
            let master_list = []
            _.each(_data, (t) => {
              ///预测订单
              let _mt = {
                id: "",
                ItemId: _.toString(t.ItemId),
                OnOrder: Number(t.OnOrder),
                Ordered: Number(t.Ordered),
                AvailOrdered: Number(t.AvailOrdered),
                AvailPhysical: Number(t.AvailPhysical),
                PhysicalValue: Number(t.PhysicalValue)
              }
              master_list.push(_mt)
            })
            let json = {}
            json.username = this.$global.global_data.local_username
            json.data = master_list
            json.SourceType = _this.exportType
            json.DataSource = _data[0].dataAreaId
            let result = null
            let result1 = null
            if (this.is_pub) {
              let _p = new FormData()
              _p.append("json", JSON.stringify(json))
              result1 = await api.query_async({
                url: api.pub_url("save", this.guest_info.idx, "generate_InventSum"),
                parameters: _p,
                method: "post",
              })
              if (
                result1 &&
                result1[0].result &&
                result1[0].result.data &&
                result1[0].result.data.Result &&
                result1[0].result.data.Result.length > 0
              ) {
                result = result1[0].result.data.Result
              }
            } else {
              result =
                await InventSumExportController.methods.SaveInventSumExport(
                  JSON.stringify(json)
                )
            }
            if (result && result.length > 0) {
              //判断后台是否写入成功
              if (result[0][0].status == 0) {
                this.$refs.InventSumExportTable.SetData([])
                this.msgToasts(this.$t("notify.import_success"), "success")
                this.$refs.InventSumExportTable.SetData([])
                cb(true, true)
              } else {
                let str = "<div><strong>" + this.$t("notify.import_failed_error") + "</strong></div>"
                _.each(result[0], (t) => {
                  if (
                    _.isNull(t.dataAreaId) ||
                    _.isNull(t.ItemId) ||
                    t.hasIt == 0 ||
                    t.hasDuplicate == 1 ||
                    t.SourceType == 0
                  ) {
                    console.log(t)
                    //标红错误行
                    let item =
                      this.$refs.InventSumExportTable.my_data[parseInt(t._id)]
                    item._rowVariant = "danger"
                    item._selected = true
                    this.$set(this.$refs.InventSumExportTable.my_data, t._id, item)
                    str += this.ErrorMsg(t)
                  }
                })
                this.msgToasts(str, "error", 0, true, "notify550")
                cb(false)
                return
              }
            } else {
              this.msgToasts(this.$t("notify.action_unsuccessfully"), "info")
              cb(false)
              return
            }
          } else {
            cb(false)
            return
          }
        })
      } else {
        cb(false)
        return
      }
    },
    ErrorMsg(data) {
      if (_.isNull(data.dataAreaId)) {
        return ("<div>" + this.$t('common.account') + ":" + "<strong>" + data.dataAreaId + "</strong>" + "，" + this.$t('common.invent') + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t('common.account') + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.ItemId)) {
        return ("<div>" + this.$t('common.account') + ":" + "<strong>" + data.dataAreaId + "</strong>" + "，" + this.$t('common.invent') + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t('common.invent') + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.hasIt == 0) {
        return ("<div>" + this.$t('common.account') + ":" + "<strong>" + data.dataAreaId + "</strong>" + "，" + this.$t('common.invent') + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t('common.invent') + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.hasDuplicate == 1) {
        return ("<div>" + this.$t('common.account') + ":" + "<strong>" + data.dataAreaId + "</strong>" + "，" + this.$t('common.invent') + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t('common.inventory') + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (data.SourceType == 0) {
        return ("<div>" + this.$t('common.account') + ":" + "<strong>" + data.dataAreaId + "</strong>" + "，" + this.$t('common.invent') + ":" + "<strong>" + data.ItemId + "</strong>" + "，<strong>" + this.$t('common.import_type') + "</strong>" + this.$t("common.error") + "</div>")
      }
      return ""
    },
    //获取物料信息
    async getNameAlias(_data) {
      let _invent_list = _.keys(_.keyBy(_data, "ItemId"))
      let _p = {
        ItemId: { in: _invent_list },
      }
      let _result = await InventTableController.methods.getData(_p)
      let _check_invent_list = []
      if (!_.isNull(_result) && _result && _result[0].length > 0) {
        _.each(_invent_list, (t) => {
          let _index = _.findIndex(_result[0], { ItemId: t })
          if (_index < 0) {
            _check_invent_list.push(t)
          }
        })
        if (_check_invent_list.length == 0) {
          return true
        } else {
          this.msgToasts(this.$t("notify.sei_invent_num_not_existe") + _.join(_check_acc_list, "，"), "error")
          return false
        }
      } else {
        this.msgToasts(this.$t("notify.sei_invent_num_not_existe"), "error")
        return false
      }
    },
  },
}
</script>
